import ResponsiveImage from "../responsiveImage";
import TechnicalContentSpec from "../technicalContentSpec";
import TechnicalContentInformation from "../technicalContentInformation";
import { SanityTechnicalContentItem } from "@sourceful/shared-types";

interface TechnicalContentProps {
  technicalContentItem: SanityTechnicalContentItem;
}

const TechnicalContent = ({ technicalContentItem }: TechnicalContentProps) => {
  const renderTechnicalContentItem = () => {
    switch (technicalContentItem._type) {
      case "responsiveImage":
        return <ResponsiveImage item={technicalContentItem} />;
      case "technicalContentSpec":
        return <TechnicalContentSpec item={technicalContentItem} />;
      case "technicalContentInformation":
        return <TechnicalContentInformation item={technicalContentItem} />;
      default:
        return <></>;
    }
  };

  return <>{renderTechnicalContentItem()}</>;
};

export default TechnicalContent;
